__turbopack_context__.v({
  "button": "NetworkAddToWallet-module__iKSLfG__button",
  "buttonPrimary": "NetworkAddToWallet-module__iKSLfG__buttonPrimary",
  "wrapper": "NetworkAddToWallet-module__iKSLfG__wrapper",
});
